import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { OnboardingResponseStatus } from 'clickNgo/configs/service/onboarding'
import { ContactWorkflowStatus, IContact } from 'clickNgo/entities/contact'
import { updateContact } from 'clickNgo/entities/contact/api'
import { getJSendErrorMessages } from 'clickNgo/helpers/api'
import Logger from 'core/utils/Logger'

import { RoleToReassign } from '../model/types'

export const reassignContactRoles = async (rolesToReassign: RoleToReassign[]): Promise<void> => {
  const uniqueContactWithUpdatedRoles = rolesToReassign
    .filter((item) => !!item.contact)
    .reduce((acc, item) => {
      if (!acc.some((c) => c.contactId === item.contact?.contactId)) {
        const contact = { ...item.contact! }
        contact.hpRoles = [...(contact.hpRoles ?? []), item.role]
        acc.push(contact)
      } else {
        const existingContact = acc.find((c) => c.contactId === item.contact?.contactId)
        if (existingContact) {
          existingContact.hpRoles.push(item.role)
        }
      }
      return acc
    }, [] as IContact[])

  for (const contact of uniqueContactWithUpdatedRoles) {
    try {
      const response = await updateContact(
        {
          ...contact,
          modifiedValues: ['hpRoles'],
          source: ProfilingRequestSource.ClickAndGoPortal,
          workflowStatus: ContactWorkflowStatus.New,
        },
        { forceRoles: true }
      )
      if (response.status === OnboardingResponseStatus.Error) {
        const { message, status } = response
        Logger.error({ message, status })
        throw new Error(message)
      }

      if (response.status === OnboardingResponseStatus.Fail) {
        const message = getJSendErrorMessages(response).join(', ')
        const status = response.status
        Logger.error({ message, status })
        throw new Error(message)
      }
    } catch (err) {
      Logger.error('Error updating contact roles', err)
      throw err
    }
  }
}
